import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcOrganization = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M10.94 3.06a1.5 1.5 0 0 1 2.12 0l3.38 3.38a1.5 1.5 0 0 1 0 2.12l-3.38 3.38a1.5 1.5 0 0 1-2.12 0L7.56 8.56a1.5 1.5 0 0 1 0-2.12l3.38-3.38Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M11 14.233V17H4a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-2h6v2a1 1 0 1 0 2 0v-2h6v2a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1h-7v-2.767a3.516 3.516 0 0 1-2 0Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcOrganization");

export { IcOrganization };
//# sourceMappingURL=ic-organization.js.map
